import "./style"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import memo from "set-state-compare/build/memo.js"
import {useNavigate} from "react-router-dom"
import {useRef} from "react"

export default memo(shapeComponent(class DropDownButton extends ShapeComponent {
  static defaultProps = {
    closeOnItemClick: true,
    disabled: false
  }

  static propTypes = PropTypesExact({
    children: PropTypes.node,
    className: PropTypes.string,
    closeOnItemClick: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    label: PropTypes.node,
    onClick: PropTypes.func,
    right: PropTypes.bool,
    small: PropTypes.bool,
    to: PropTypes.string,
    tooltip: PropTypes.node
  })

  navigate = this.hookField()
  buttonRef = this.hookField()
  state = {
    toggled: false
  }

  setup() {
    this.navigate = useNavigate()
    this.buttonRef = useRef(null)
  }

  onClick = (e) => {
    e.preventDefault()

    const {disabled, onClick: onClickFromProps, to} = this.props

    if (disabled) {
      return
    }

    if (onClickFromProps) {
      onClickFromProps(e)
    } else if (to) {
      this.tt.navigate(to)
    } else {
      this.s.toggled = !this.s.toggled
    }
  }

  onDropDownMenuClicked = () => {
    const {closeOnItemClick} = this.props

    if (closeOnItemClick) {
      this.s.toggled = false
    }
  }

  onToggleDropDown = (e) => {
    e.preventDefault()

    const {disabled} = this.props

    if (disabled) {
      return
    }

    this.s.toggled = !this.s.toggled
  }

  onWindowMouseUp = (e) => {
    if (!this.s.toggled || this.tt.buttonRef.current?.contains(e.target)) {
      return
    }

    this.s.toggled = false
  }

  render() {
    const {className, children, disabled, icon, label, right, small, tooltip} = this.props
    const {toggled} = this.s

    return (
      <div
        className={classNames("components-shared-drop-down-button", className, {disabled, small})}
        data-toggled={toggled}
        ref={this.tt.buttonRef}
        title={disabled && tooltip ? tooltip : undefined}
      >
        <EventListener event="mouseup" onCalled={this.onWindowMouseUp} target={window} />

        <div className="d-flex">
          <div className="primary-drop-down-option" onClick={this.onClick}>
            {icon &&
              <Icon icon={icon} />
            }
            {label}
          </div>
          <div className="angle-down-button toggle-drop-down-button" onClick={this.onToggleDropDown}>
            <i className="la la-angle-down" />
          </div>
        </div>
        {toggled &&
          <div className="drop-down-options-container" data-right={right} onClick={this.onDropDownMenuClicked}>
            {children}
          </div>
        }
      </div>
    )
  }
}))
